import React, { useCallback, useEffect, useState } from "react";

import api from "../../util/panelApi";
import { PageHead, Pager, Person, Table, Tabs, Tiles, fmt } from "./kit";

const cell = { padding: "6px 9px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13 };
const small = { fontSize: 12, color: "#6B7280" };

/// Davet kodu: herkesin kodu kendi ID numarasıdır.
const Invite = () => {
  const [tab, setTab] = useState("ayar");
  const [cfg, setCfg] = useState(null);
  const [rows, setRows] = useState({ data: [], total: 0, totalPaid: 0 });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const r = await api.config();
    if (r?.status) {
      setCfg({
        inviteEnabled: r.config.inviteEnabled !== false,
        inviteJoinBonus: Number(r.config.inviteJoinBonus) || 0,
        inviteInviterBonus: Number(r.config.inviteInviterBonus) || 0,
        inviteMaxAgeDays: Number(r.config.inviteMaxAgeDays) || 0,
        inviteTiers: r.config.inviteTiers || [],
        welcomeBonusOn: r.config.welcomeBonusOn !== false,
        welcomeBonusCoin: Number(r.config.welcomeBonusCoin) || 0,
      });
    }
  }, []);

  const loadRows = useCallback(async () => {
    setLoading(true);
    const r = await api.invites({ start: page, limit: 25 });
    if (r?.status) setRows(r);
    setLoading(false);
  }, [page]);

  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    if (tab === "liste") loadRows();
  }, [tab, loadRows]);

  const save = async () => {
    setSaving(true);
    const r = await api.saveConfig(cfg);
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    load();
  };

  const setTier = (i, k, v) =>
    setCfg({ ...cfg, inviteTiers: cfg.inviteTiers.map((t, j) => (i === j ? { ...t, [k]: Number(v) } : t)) });
  const addTier = () => setCfg({ ...cfg, inviteTiers: [...cfg.inviteTiers, { spend: 0, coin: 0 }] });
  const delTier = (i) => setCfg({ ...cfg, inviteTiers: cfg.inviteTiers.filter((_, j) => j !== i) });

  if (!cfg) return <div className="badu-empty">Yükleniyor…</div>;

  const perInvite = cfg.inviteJoinBonus + cfg.inviteInviterBonus;
  const maxPer = perInvite + cfg.inviteTiers.reduce((a, t) => a + (Number(t.coin) || 0), 0);

  return (
    <>
      <PageHead
        title="Davet Kodu"
        sub="Herkesin davet kodu kendi ID numarasıdır. Kod girilince iki tarafa da coin verilir; davet edilen harcadıkça davet edene ek ödül düşer."
      />

      <Tiles
        items={[
          { label: "Durum", value: cfg.inviteEnabled ? "Açık" : "Kapalı" },
          { label: "Toplam davet", value: fmt(rows.total) },
          { label: "Dağıtılan coin", value: fmt(rows.totalPaid) },
          { label: "Davet başına anlık", value: fmt(perInvite) },
          { label: "Davet başına en fazla", value: fmt(maxPer) },
        ]}
      />

      <Tabs
        tabs={[
          ["ayar", "Ayarlar"],
          ["liste", "En çok davet edenler"],
        ]}
        value={tab}
        onChange={setTab}
      />

      {tab === "ayar" && (
        <div className="card">
          <div className="card-body" style={{ maxWidth: 640 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
              <input
                type="checkbox"
                checked={cfg.inviteEnabled}
                onChange={(e) => setCfg({ ...cfg, inviteEnabled: e.target.checked })}
              />
              <b>Davet sistemi açık</b>
            </label>

            <div className="d-flex" style={{ gap: 14, flexWrap: "wrap", marginBottom: 16 }}>
              <div>
                <div style={small}>Kodu girene (coin)</div>
                <input
                  style={{ ...cell, width: 140 }}
                  type="number"
                  value={cfg.inviteJoinBonus}
                  onChange={(e) => setCfg({ ...cfg, inviteJoinBonus: Number(e.target.value) })}
                />
              </div>
              <div>
                <div style={small}>Davet edene (coin)</div>
                <input
                  style={{ ...cell, width: 140 }}
                  type="number"
                  value={cfg.inviteInviterBonus}
                  onChange={(e) => setCfg({ ...cfg, inviteInviterBonus: Number(e.target.value) })}
                />
              </div>
              <div>
                <div style={small}>Kod girme süresi (gün)</div>
                <input
                  style={{ ...cell, width: 140 }}
                  type="number"
                  value={cfg.inviteMaxAgeDays}
                  onChange={(e) => setCfg({ ...cfg, inviteMaxAgeDays: Number(e.target.value) })}
                />
                <div style={{ ...small, maxWidth: 220 }}>
                  Hesap açıldıktan sonra bu süre içinde kod girilebilir. 0 = sınırsız.
                </div>
              </div>
            </div>

            <div style={{ border: "1px solid #FDE68A", background: "#FFFBEB", borderRadius: 10, padding: 12, marginBottom: 16 }}>
              <label className="d-flex align-items-center" style={{ gap: 8, marginBottom: 8 }}>
                <input type="checkbox" checked={cfg.welcomeBonusOn} onChange={(e) => setCfg({ ...cfg, welcomeBonusOn: e.target.checked })} />
                <b>Hoş geldin bonusu (oyunlar)</b>
              </label>
              <div style={{ ...small, marginBottom: 8 }}>
                Yeni kullanıcı AYVO oyunlarına ilk girişinde coin'i bu tutarın altındaysa bu tutara tamamlanır. Hesap başına ve telefon başına bir kez. (Davetten ayrıdır.)
              </div>
              <div style={small}>Tamamlanacak tutar (coin)</div>
              <input style={{ ...cell, width: 140 }} type="number" min="0" value={cfg.welcomeBonusCoin} onChange={(e) => setCfg({ ...cfg, welcomeBonusCoin: Number(e.target.value) })} />
            </div>

            <b style={{ fontSize: 14 }}>Harcama ödülleri</b>
            <div style={{ ...small, marginBottom: 8 }}>
              Davet edilen bu kadar coin harcayınca, davet edene ödül verilir.
            </div>
            {cfg.inviteTiers.map((t, i) => (
              <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 8 }} key={i}>
                <span style={{ ...small, width: 20 }}>{i + 1}</span>
                <div>
                  <div style={small}>Harcama</div>
                  <input
                    style={{ ...cell, width: 140 }}
                    type="number"
                    value={t.spend || 0}
                    onChange={(e) => setTier(i, "spend", e.target.value)}
                  />
                </div>
                <div>
                  <div style={small}>Ödül</div>
                  <input
                    style={{ ...cell, width: 140 }}
                    type="number"
                    value={t.coin || 0}
                    onChange={(e) => setTier(i, "coin", e.target.value)}
                  />
                </div>
                <button
                  className="btn btn-sm btn-outline-danger"
                  style={{ alignSelf: "flex-end" }}
                  onClick={() => delTier(i)}
                >
                  Sil
                </button>
              </div>
            ))}

            <div className="d-flex" style={{ gap: 8, marginTop: 12 }}>
              <button className="btn btn-outline-secondary btn-sm" onClick={addTier}>
                Eşik ekle
              </button>
              <button className="btn btn-primary btn-sm" disabled={saving} onClick={save}>
                {saving ? "Kaydediliyor…" : "Kaydet"}
              </button>
            </div>
          </div>
        </div>
      )}

      {tab === "liste" && (
        <>
          <Table
            head={["Kullanıcı", "Davet ettiği", "Onların harcadığı", "Aldığı coin"]}
            loading={loading}
            empty="Henüz davet yok."
            rows={rows.data.map((r) => (
              <tr key={r.userId}>
                <td>
                  <Person image={r.image} name={r.name} />
                  <div style={small}>ID {r.uniqueId}</div>
                </td>
                <td>
                  <b>{fmt(r.invited)}</b>
                </td>
                <td style={small}>{fmt(r.spent)}</td>
                <td>
                  <b>{fmt(r.paid)}</b>
                </td>
              </tr>
            ))}
          />
          <Pager page={page} size={25} total={rows.total} onChange={setPage} />
        </>
      )}
    </>
  );
};

export default Invite;
